import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Icons } from "../../assets";
import "./VisitCancelModal.css";
import CustomButton from "../Buttons/CustomButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useFetchCancelReasonsMutation } from "../../features/athena/athenaApiSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import Loading from "../Loading";

const VisitCancelModal = ({
  open: isOpen,
  handleClose,
  handleCancel,
  selectedVisit,
}) => {
  const user = useSelector(selectUser);
  const [open, setOpen] = useState(isOpen);
  const [reasons, setReasons] = useState([]);
  const [selected, setSelected] = useState("");
  const [description, setDescription] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openReasons = Boolean(anchorEl);
  const [fetchCancelReasons, { isLoading: cancelReasonsLoading }] =
    useFetchCancelReasonsMutation();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseReasons = () => {
    setAnchorEl(null);
  };

  const handleSelect = (data) => {
    setSelected(data);
    setAnchorEl(null);
  };

  const onClose = () => {
    setOpen(false);
    handleClose();
  };
  const onCancel = () => {
    setOpen(false);
    handleCancel({
      reason: selected?.name,
      reasonId: selected?.appointmentcancelreasonid,
      description,
    });
  };

  React.useEffect(() => {
    if (user?.organisation?.practiceId) {
      fetchCancelReasons({ practiceId: user?.organisation?.practiceId })
        .unwrap()
        .then((res) => {
          setReasons(res.data);
        });
    }
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"sm"}
      fullWidth
    >
      {cancelReasonsLoading && <Loading loading={cancelReasonsLoading} />}
      <Grid className="d-flex justify-content-between align-items-center mx-3 mt-3">
        <Grid className="d-flex align-items-center">
          <img src={Icons.Cancel_Icon} className="icon" alt="cancel icon" />
          <Typography className="cancel-title px-2">Cancel Visit</Typography>
        </Grid>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <DialogContent>
        <DialogContentText
        // className="cancel-subtext"
        >
          Based on their last visit date and rotation schedule,{" "}
          <span className="bold-600">"{selectedVisit?.patient?.name}"</span> is
          overdue by{" "}
          <span className="bold-600">
            {Math.abs(selectedVisit?.slack || 0)} days
          </span>{" "}
          for an appointment. <br />
          <br /> Are you sure you want to cancel this appointment? This action
          cannot be undone.
        </DialogContentText>
      </DialogContent>
      <Button
        id="region-button"
        aria-controls={openReasons ? "region-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openReasons ? "true" : undefined}
        onClick={handleClick}
        className="btn text-capitalize reasons-dropdown note-text mx-4 my-3 px-2 py-1 d-flex justify-content-between"
      >
        <Typography>{selected?.name || "Reason for cancellation"}</Typography>
        <KeyboardArrowDownIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openReasons}
        onClose={handleCloseReasons}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {reasons?.map((reason) => {
          return (
            <MenuItem key={reason.name} onClick={() => handleSelect(reason)}>
              {reason.name}
            </MenuItem>
          );
        })}
      </Menu>

      <input
        type="text"
        placeholder="Add a note (optional)"
        className="note-text mx-4 px-2 py-1"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <DialogActions>
        <DialogActions>
          <CustomButton className={"button-dont"} onClick={onClose}>
            Don’t cancel visit
          </CustomButton>
          <CustomButton
            className={"button-cancel"}
            onClick={onCancel}
            disabled={!selected}
          >
            Cancel Visit
          </CustomButton>
        </DialogActions>
      </DialogActions>
    </Dialog>
  );
};

export default VisitCancelModal;
